/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.route'
import { Route as TeacherRouteRouteImport } from './routes/teacher.route'
import { Route as PrivacypolicyRouteRouteImport } from './routes/privacypolicy.route'
import { Route as LoginRouteRouteImport } from './routes/login.route'
import { Route as DownloadRouteRouteImport } from './routes/download.route'
import { Route as AdminRouteRouteImport } from './routes/admin.route'
import { Route as IndexRouteRouteImport } from './routes/index.route'
import { Route as TeacherIndexRouteRouteImport } from './routes/teacher/index.route'
import { Route as AdminIndexRouteRouteImport } from './routes/admin/index.route'
import { Route as HomeworkHomeworkIdRouteRouteImport } from './routes/homework/$homeworkId.route'
import { Route as AdminUsersRouteRouteImport } from './routes/admin/users.route'
import { Route as AdminTrashRouteRouteImport } from './routes/admin/trash.route'
import { Route as AdminPresetsRouteRouteImport } from './routes/admin/presets.route'
import { Route as AdminErrorsRouteRouteImport } from './routes/admin/errors.route'
import { Route as AdminApksRouteRouteImport } from './routes/admin/apks.route'
import { Route as AdminAiUsageRouteRouteImport } from './routes/admin/ai-usage.route'
import { Route as AdminAccessRouteRouteImport } from './routes/admin/access.route'
import { Route as TeacherSelfStudyRecordIndexRouteRouteImport } from './routes/teacher/self-study-record/index.route'
import { Route as TeacherClassroomsIndexRouteRouteImport } from './routes/teacher/classrooms/index.route'
import { Route as TeacherCheckIndexRouteRouteImport } from './routes/teacher/check/index.route'
import { Route as TeacherBooksIndexRouteRouteImport } from './routes/teacher/books/index.route'
import { Route as TeacherAssignIndexRouteRouteImport } from './routes/teacher/assign/index.route'
import { Route as AdminWordsIndexRouteRouteImport } from './routes/admin/words/index.route'
import { Route as AdminSpeechIndexRouteRouteImport } from './routes/admin/speech/index.route'
import { Route as AdminServiceSettingsIndexRouteRouteImport } from './routes/admin/service-settings/index.route'
import { Route as AdminSchoolsIndexRouteRouteImport } from './routes/admin/schools/index.route'
import { Route as AdminPhonemeLabIndexRouteRouteImport } from './routes/admin/phoneme-lab/index.route'
import { Route as AdminFsrsIndexRouteRouteImport } from './routes/admin/fsrs/index.route'
import { Route as AdminClassroomsIndexRouteRouteImport } from './routes/admin/classrooms/index.route'
import { Route as AdminBooksIndexRouteRouteImport } from './routes/admin/books/index.route'
import { Route as AdminAnalyticsIndexRouteRouteImport } from './routes/admin/analytics/index.route'
import { Route as TeacherCheckBatchIdRouteRouteImport } from './routes/teacher/check/$batchId.route'
import { Route as AdminSlideSlideIdRouteRouteImport } from './routes/admin/slide/$slideId.route'
import { Route as AdminFsrsSystemRouteRouteImport } from './routes/admin/fsrs/system.route'
import { Route as AdminFsrsSchoolsRouteRouteImport } from './routes/admin/fsrs/schools.route'
import { Route as AdminFsrsDocsRouteRouteImport } from './routes/admin/fsrs/docs.route'
import { Route as TeacherSelfStudyRecordClassroomIdIndexRouteRouteImport } from './routes/teacher/self-study-record/$classroomId/index.route'
import { Route as TeacherClassroomsClassroomIdIndexRouteRouteImport } from './routes/teacher/classrooms/$classroomId/index.route'
import { Route as AdminSchoolsSchoolIdIndexRouteRouteImport } from './routes/admin/schools/$schoolId/index.route'
import { Route as AdminProjectProjectIdIndexRouteRouteImport } from './routes/admin/project/$projectId/index.route'
import { Route as AdminLessonLessonIdIndexRouteRouteImport } from './routes/admin/lesson/$lessonId/index.route'
import { Route as AdminClassroomsClassroomIdIndexRouteRouteImport } from './routes/admin/classrooms/$classroomId/index.route'
import { Route as AdminProjectProjectIdTrashRouteRouteImport } from './routes/admin/project/$projectId/trash.route'
import { Route as AdminProjectProjectIdDraftsRouteRouteImport } from './routes/admin/project/$projectId/drafts.route'
import { Route as AdminLessonLessonIdTrashRouteRouteImport } from './routes/admin/lesson/$lessonId/trash.route'
import { Route as AdminLessonLessonIdDraftsRouteRouteImport } from './routes/admin/lesson/$lessonId/drafts.route'
import { Route as TeacherBooksLessonsLessonIdIndexRouteRouteImport } from './routes/teacher/books/lessons/$lessonId/index.route'
import { Route as TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRouteImport } from './routes/teacher/classrooms/$classroomId/students/$studentId/index.route'
import { Route as AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRouteImport } from './routes/admin/classrooms/$classroomId/students/$studentId/index.route'
import { Route as TeacherBooksLessonsLessonIdSlidesSlideIdRouteRouteImport } from './routes/teacher/books/lessons/$lessonId/slides/$slideId.route'
import { Route as TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRouteImport } from './routes/teacher/classrooms/$classroomId/students/$studentId/score/index.route'
import { Route as TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRouteImport } from './routes/teacher/classrooms/$classroomId/students/$studentId/report/index.route'
import { Route as TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRouteImport } from './routes/teacher/classrooms/$classroomId/students/$studentId/homework/index.route'
import { Route as AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRouteImport } from './routes/admin/classrooms/$classroomId/students/$studentId/score/index.route'
import { Route as AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRouteImport } from './routes/admin/classrooms/$classroomId/students/$studentId/report/index.route'
import { Route as AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRouteImport } from './routes/admin/classrooms/$classroomId/students/$studentId/homework/index.route'
import { Route as TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRouteImport } from './routes/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId.route'
import { Route as AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRouteImport } from './routes/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId.route'

const TeacherRouteRoute = TeacherRouteRouteImport.update({
  id: '/teacher',
  path: '/teacher',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacypolicyRouteRoute = PrivacypolicyRouteRouteImport.update({
  id: '/privacypolicy',
  path: '/privacypolicy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRouteRoute = DownloadRouteRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherIndexRouteRoute = TeacherIndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TeacherRouteRoute,
} as any)
const AdminIndexRouteRoute = AdminIndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const HomeworkHomeworkIdRouteRoute = HomeworkHomeworkIdRouteRouteImport.update({
  id: '/homework/$homeworkId',
  path: '/homework/$homeworkId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRouteRoute = AdminUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTrashRouteRoute = AdminTrashRouteRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPresetsRouteRoute = AdminPresetsRouteRouteImport.update({
  id: '/presets',
  path: '/presets',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminErrorsRouteRoute = AdminErrorsRouteRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminApksRouteRoute = AdminApksRouteRouteImport.update({
  id: '/apks',
  path: '/apks',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAiUsageRouteRoute = AdminAiUsageRouteRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessRouteRoute = AdminAccessRouteRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TeacherSelfStudyRecordIndexRouteRoute =
  TeacherSelfStudyRecordIndexRouteRouteImport.update({
    id: '/self-study-record/',
    path: '/self-study-record/',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const TeacherClassroomsIndexRouteRoute =
  TeacherClassroomsIndexRouteRouteImport.update({
    id: '/classrooms/',
    path: '/classrooms/',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const TeacherCheckIndexRouteRoute = TeacherCheckIndexRouteRouteImport.update({
  id: '/check/',
  path: '/check/',
  getParentRoute: () => TeacherRouteRoute,
} as any)
const TeacherBooksIndexRouteRoute = TeacherBooksIndexRouteRouteImport.update({
  id: '/books/',
  path: '/books/',
  getParentRoute: () => TeacherRouteRoute,
} as any)
const TeacherAssignIndexRouteRoute = TeacherAssignIndexRouteRouteImport.update({
  id: '/assign/',
  path: '/assign/',
  getParentRoute: () => TeacherRouteRoute,
} as any)
const AdminWordsIndexRouteRoute = AdminWordsIndexRouteRouteImport.update({
  id: '/words/',
  path: '/words/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSpeechIndexRouteRoute = AdminSpeechIndexRouteRouteImport.update({
  id: '/speech/',
  path: '/speech/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminServiceSettingsIndexRouteRoute =
  AdminServiceSettingsIndexRouteRouteImport.update({
    id: '/service-settings/',
    path: '/service-settings/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSchoolsIndexRouteRoute = AdminSchoolsIndexRouteRouteImport.update({
  id: '/schools/',
  path: '/schools/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPhonemeLabIndexRouteRoute =
  AdminPhonemeLabIndexRouteRouteImport.update({
    id: '/phoneme-lab/',
    path: '/phoneme-lab/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminFsrsIndexRouteRoute = AdminFsrsIndexRouteRouteImport.update({
  id: '/fsrs/',
  path: '/fsrs/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminClassroomsIndexRouteRoute =
  AdminClassroomsIndexRouteRouteImport.update({
    id: '/classrooms/',
    path: '/classrooms/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBooksIndexRouteRoute = AdminBooksIndexRouteRouteImport.update({
  id: '/books/',
  path: '/books/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAnalyticsIndexRouteRoute =
  AdminAnalyticsIndexRouteRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const TeacherCheckBatchIdRouteRoute =
  TeacherCheckBatchIdRouteRouteImport.update({
    id: '/check/$batchId',
    path: '/check/$batchId',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const AdminSlideSlideIdRouteRoute = AdminSlideSlideIdRouteRouteImport.update({
  id: '/slide/$slideId',
  path: '/slide/$slideId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFsrsSystemRouteRoute = AdminFsrsSystemRouteRouteImport.update({
  id: '/fsrs/system',
  path: '/fsrs/system',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFsrsSchoolsRouteRoute = AdminFsrsSchoolsRouteRouteImport.update({
  id: '/fsrs/schools',
  path: '/fsrs/schools',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFsrsDocsRouteRoute = AdminFsrsDocsRouteRouteImport.update({
  id: '/fsrs/docs',
  path: '/fsrs/docs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TeacherSelfStudyRecordClassroomIdIndexRouteRoute =
  TeacherSelfStudyRecordClassroomIdIndexRouteRouteImport.update({
    id: '/self-study-record/$classroomId/',
    path: '/self-study-record/$classroomId/',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const TeacherClassroomsClassroomIdIndexRouteRoute =
  TeacherClassroomsClassroomIdIndexRouteRouteImport.update({
    id: '/classrooms/$classroomId/',
    path: '/classrooms/$classroomId/',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const AdminSchoolsSchoolIdIndexRouteRoute =
  AdminSchoolsSchoolIdIndexRouteRouteImport.update({
    id: '/schools/$schoolId/',
    path: '/schools/$schoolId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProjectProjectIdIndexRouteRoute =
  AdminProjectProjectIdIndexRouteRouteImport.update({
    id: '/project/$projectId/',
    path: '/project/$projectId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminLessonLessonIdIndexRouteRoute =
  AdminLessonLessonIdIndexRouteRouteImport.update({
    id: '/lesson/$lessonId/',
    path: '/lesson/$lessonId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminClassroomsClassroomIdIndexRouteRoute =
  AdminClassroomsClassroomIdIndexRouteRouteImport.update({
    id: '/classrooms/$classroomId/',
    path: '/classrooms/$classroomId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProjectProjectIdTrashRouteRoute =
  AdminProjectProjectIdTrashRouteRouteImport.update({
    id: '/project/$projectId/trash',
    path: '/project/$projectId/trash',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProjectProjectIdDraftsRouteRoute =
  AdminProjectProjectIdDraftsRouteRouteImport.update({
    id: '/project/$projectId/drafts',
    path: '/project/$projectId/drafts',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminLessonLessonIdTrashRouteRoute =
  AdminLessonLessonIdTrashRouteRouteImport.update({
    id: '/lesson/$lessonId/trash',
    path: '/lesson/$lessonId/trash',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminLessonLessonIdDraftsRouteRoute =
  AdminLessonLessonIdDraftsRouteRouteImport.update({
    id: '/lesson/$lessonId/drafts',
    path: '/lesson/$lessonId/drafts',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const TeacherBooksLessonsLessonIdIndexRouteRoute =
  TeacherBooksLessonsLessonIdIndexRouteRouteImport.update({
    id: '/books/lessons/$lessonId/',
    path: '/books/lessons/$lessonId/',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute =
  TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRouteImport.update({
    id: '/classrooms/$classroomId/students/$studentId/',
    path: '/classrooms/$classroomId/students/$studentId/',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute =
  AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRouteImport.update({
    id: '/classrooms/$classroomId/students/$studentId/',
    path: '/classrooms/$classroomId/students/$studentId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute =
  TeacherBooksLessonsLessonIdSlidesSlideIdRouteRouteImport.update({
    id: '/books/lessons/$lessonId/slides/$slideId',
    path: '/books/lessons/$lessonId/slides/$slideId',
    getParentRoute: () => TeacherRouteRoute,
  } as any)
const TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute =
  TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRouteImport.update(
    {
      id: '/classrooms/$classroomId/students/$studentId/score/',
      path: '/classrooms/$classroomId/students/$studentId/score/',
      getParentRoute: () => TeacherRouteRoute,
    } as any,
  )
const TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute =
  TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRouteImport.update(
    {
      id: '/classrooms/$classroomId/students/$studentId/report/',
      path: '/classrooms/$classroomId/students/$studentId/report/',
      getParentRoute: () => TeacherRouteRoute,
    } as any,
  )
const TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute =
  TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRouteImport.update(
    {
      id: '/classrooms/$classroomId/students/$studentId/homework/',
      path: '/classrooms/$classroomId/students/$studentId/homework/',
      getParentRoute: () => TeacherRouteRoute,
    } as any,
  )
const AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute =
  AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRouteImport.update({
    id: '/classrooms/$classroomId/students/$studentId/score/',
    path: '/classrooms/$classroomId/students/$studentId/score/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute =
  AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRouteImport.update(
    {
      id: '/classrooms/$classroomId/students/$studentId/report/',
      path: '/classrooms/$classroomId/students/$studentId/report/',
      getParentRoute: () => AdminRouteRoute,
    } as any,
  )
const AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute =
  AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRouteImport.update(
    {
      id: '/classrooms/$classroomId/students/$studentId/homework/',
      path: '/classrooms/$classroomId/students/$studentId/homework/',
      getParentRoute: () => AdminRouteRoute,
    } as any,
  )
const TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute =
  TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRouteImport.update(
    {
      id: '/classrooms/$classroomId/students/$studentId/homework/$homeworkId',
      path: '/classrooms/$classroomId/students/$studentId/homework/$homeworkId',
      getParentRoute: () => TeacherRouteRoute,
    } as any,
  )
const AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute =
  AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRouteImport.update(
    {
      id: '/classrooms/$classroomId/students/$studentId/homework/$homeworkId',
      path: '/classrooms/$classroomId/students/$studentId/homework/$homeworkId',
      getParentRoute: () => AdminRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/download': typeof DownloadRouteRoute
  '/login': typeof LoginRouteRoute
  '/privacypolicy': typeof PrivacypolicyRouteRoute
  '/teacher': typeof TeacherRouteRouteWithChildren
  '/admin/access': typeof AdminAccessRouteRoute
  '/admin/ai-usage': typeof AdminAiUsageRouteRoute
  '/admin/apks': typeof AdminApksRouteRoute
  '/admin/errors': typeof AdminErrorsRouteRoute
  '/admin/presets': typeof AdminPresetsRouteRoute
  '/admin/trash': typeof AdminTrashRouteRoute
  '/admin/users': typeof AdminUsersRouteRoute
  '/homework/$homeworkId': typeof HomeworkHomeworkIdRouteRoute
  '/admin/': typeof AdminIndexRouteRoute
  '/teacher/': typeof TeacherIndexRouteRoute
  '/admin/fsrs/docs': typeof AdminFsrsDocsRouteRoute
  '/admin/fsrs/schools': typeof AdminFsrsSchoolsRouteRoute
  '/admin/fsrs/system': typeof AdminFsrsSystemRouteRoute
  '/admin/slide/$slideId': typeof AdminSlideSlideIdRouteRoute
  '/teacher/check/$batchId': typeof TeacherCheckBatchIdRouteRoute
  '/admin/analytics': typeof AdminAnalyticsIndexRouteRoute
  '/admin/books': typeof AdminBooksIndexRouteRoute
  '/admin/classrooms': typeof AdminClassroomsIndexRouteRoute
  '/admin/fsrs': typeof AdminFsrsIndexRouteRoute
  '/admin/phoneme-lab': typeof AdminPhonemeLabIndexRouteRoute
  '/admin/schools': typeof AdminSchoolsIndexRouteRoute
  '/admin/service-settings': typeof AdminServiceSettingsIndexRouteRoute
  '/admin/speech': typeof AdminSpeechIndexRouteRoute
  '/admin/words': typeof AdminWordsIndexRouteRoute
  '/teacher/assign': typeof TeacherAssignIndexRouteRoute
  '/teacher/books': typeof TeacherBooksIndexRouteRoute
  '/teacher/check': typeof TeacherCheckIndexRouteRoute
  '/teacher/classrooms': typeof TeacherClassroomsIndexRouteRoute
  '/teacher/self-study-record': typeof TeacherSelfStudyRecordIndexRouteRoute
  '/admin/lesson/$lessonId/drafts': typeof AdminLessonLessonIdDraftsRouteRoute
  '/admin/lesson/$lessonId/trash': typeof AdminLessonLessonIdTrashRouteRoute
  '/admin/project/$projectId/drafts': typeof AdminProjectProjectIdDraftsRouteRoute
  '/admin/project/$projectId/trash': typeof AdminProjectProjectIdTrashRouteRoute
  '/admin/classrooms/$classroomId': typeof AdminClassroomsClassroomIdIndexRouteRoute
  '/admin/lesson/$lessonId': typeof AdminLessonLessonIdIndexRouteRoute
  '/admin/project/$projectId': typeof AdminProjectProjectIdIndexRouteRoute
  '/admin/schools/$schoolId': typeof AdminSchoolsSchoolIdIndexRouteRoute
  '/teacher/classrooms/$classroomId': typeof TeacherClassroomsClassroomIdIndexRouteRoute
  '/teacher/self-study-record/$classroomId': typeof TeacherSelfStudyRecordClassroomIdIndexRouteRoute
  '/teacher/books/lessons/$lessonId': typeof TeacherBooksLessonsLessonIdIndexRouteRoute
  '/teacher/books/lessons/$lessonId/slides/$slideId': typeof TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId': typeof AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId': typeof TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId': typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId': typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/homework': typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/report': typeof AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/score': typeof AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/homework': typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/report': typeof TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/score': typeof TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRouteRoute
  '/download': typeof DownloadRouteRoute
  '/login': typeof LoginRouteRoute
  '/privacypolicy': typeof PrivacypolicyRouteRoute
  '/admin/access': typeof AdminAccessRouteRoute
  '/admin/ai-usage': typeof AdminAiUsageRouteRoute
  '/admin/apks': typeof AdminApksRouteRoute
  '/admin/errors': typeof AdminErrorsRouteRoute
  '/admin/presets': typeof AdminPresetsRouteRoute
  '/admin/trash': typeof AdminTrashRouteRoute
  '/admin/users': typeof AdminUsersRouteRoute
  '/homework/$homeworkId': typeof HomeworkHomeworkIdRouteRoute
  '/admin': typeof AdminIndexRouteRoute
  '/teacher': typeof TeacherIndexRouteRoute
  '/admin/fsrs/docs': typeof AdminFsrsDocsRouteRoute
  '/admin/fsrs/schools': typeof AdminFsrsSchoolsRouteRoute
  '/admin/fsrs/system': typeof AdminFsrsSystemRouteRoute
  '/admin/slide/$slideId': typeof AdminSlideSlideIdRouteRoute
  '/teacher/check/$batchId': typeof TeacherCheckBatchIdRouteRoute
  '/admin/analytics': typeof AdminAnalyticsIndexRouteRoute
  '/admin/books': typeof AdminBooksIndexRouteRoute
  '/admin/classrooms': typeof AdminClassroomsIndexRouteRoute
  '/admin/fsrs': typeof AdminFsrsIndexRouteRoute
  '/admin/phoneme-lab': typeof AdminPhonemeLabIndexRouteRoute
  '/admin/schools': typeof AdminSchoolsIndexRouteRoute
  '/admin/service-settings': typeof AdminServiceSettingsIndexRouteRoute
  '/admin/speech': typeof AdminSpeechIndexRouteRoute
  '/admin/words': typeof AdminWordsIndexRouteRoute
  '/teacher/assign': typeof TeacherAssignIndexRouteRoute
  '/teacher/books': typeof TeacherBooksIndexRouteRoute
  '/teacher/check': typeof TeacherCheckIndexRouteRoute
  '/teacher/classrooms': typeof TeacherClassroomsIndexRouteRoute
  '/teacher/self-study-record': typeof TeacherSelfStudyRecordIndexRouteRoute
  '/admin/lesson/$lessonId/drafts': typeof AdminLessonLessonIdDraftsRouteRoute
  '/admin/lesson/$lessonId/trash': typeof AdminLessonLessonIdTrashRouteRoute
  '/admin/project/$projectId/drafts': typeof AdminProjectProjectIdDraftsRouteRoute
  '/admin/project/$projectId/trash': typeof AdminProjectProjectIdTrashRouteRoute
  '/admin/classrooms/$classroomId': typeof AdminClassroomsClassroomIdIndexRouteRoute
  '/admin/lesson/$lessonId': typeof AdminLessonLessonIdIndexRouteRoute
  '/admin/project/$projectId': typeof AdminProjectProjectIdIndexRouteRoute
  '/admin/schools/$schoolId': typeof AdminSchoolsSchoolIdIndexRouteRoute
  '/teacher/classrooms/$classroomId': typeof TeacherClassroomsClassroomIdIndexRouteRoute
  '/teacher/self-study-record/$classroomId': typeof TeacherSelfStudyRecordClassroomIdIndexRouteRoute
  '/teacher/books/lessons/$lessonId': typeof TeacherBooksLessonsLessonIdIndexRouteRoute
  '/teacher/books/lessons/$lessonId/slides/$slideId': typeof TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId': typeof AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId': typeof TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId': typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId': typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/homework': typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/report': typeof AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/score': typeof AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/homework': typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/report': typeof TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/score': typeof TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRouteRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/download': typeof DownloadRouteRoute
  '/login': typeof LoginRouteRoute
  '/privacypolicy': typeof PrivacypolicyRouteRoute
  '/teacher': typeof TeacherRouteRouteWithChildren
  '/admin/access': typeof AdminAccessRouteRoute
  '/admin/ai-usage': typeof AdminAiUsageRouteRoute
  '/admin/apks': typeof AdminApksRouteRoute
  '/admin/errors': typeof AdminErrorsRouteRoute
  '/admin/presets': typeof AdminPresetsRouteRoute
  '/admin/trash': typeof AdminTrashRouteRoute
  '/admin/users': typeof AdminUsersRouteRoute
  '/homework/$homeworkId': typeof HomeworkHomeworkIdRouteRoute
  '/admin/': typeof AdminIndexRouteRoute
  '/teacher/': typeof TeacherIndexRouteRoute
  '/admin/fsrs/docs': typeof AdminFsrsDocsRouteRoute
  '/admin/fsrs/schools': typeof AdminFsrsSchoolsRouteRoute
  '/admin/fsrs/system': typeof AdminFsrsSystemRouteRoute
  '/admin/slide/$slideId': typeof AdminSlideSlideIdRouteRoute
  '/teacher/check/$batchId': typeof TeacherCheckBatchIdRouteRoute
  '/admin/analytics/': typeof AdminAnalyticsIndexRouteRoute
  '/admin/books/': typeof AdminBooksIndexRouteRoute
  '/admin/classrooms/': typeof AdminClassroomsIndexRouteRoute
  '/admin/fsrs/': typeof AdminFsrsIndexRouteRoute
  '/admin/phoneme-lab/': typeof AdminPhonemeLabIndexRouteRoute
  '/admin/schools/': typeof AdminSchoolsIndexRouteRoute
  '/admin/service-settings/': typeof AdminServiceSettingsIndexRouteRoute
  '/admin/speech/': typeof AdminSpeechIndexRouteRoute
  '/admin/words/': typeof AdminWordsIndexRouteRoute
  '/teacher/assign/': typeof TeacherAssignIndexRouteRoute
  '/teacher/books/': typeof TeacherBooksIndexRouteRoute
  '/teacher/check/': typeof TeacherCheckIndexRouteRoute
  '/teacher/classrooms/': typeof TeacherClassroomsIndexRouteRoute
  '/teacher/self-study-record/': typeof TeacherSelfStudyRecordIndexRouteRoute
  '/admin/lesson/$lessonId/drafts': typeof AdminLessonLessonIdDraftsRouteRoute
  '/admin/lesson/$lessonId/trash': typeof AdminLessonLessonIdTrashRouteRoute
  '/admin/project/$projectId/drafts': typeof AdminProjectProjectIdDraftsRouteRoute
  '/admin/project/$projectId/trash': typeof AdminProjectProjectIdTrashRouteRoute
  '/admin/classrooms/$classroomId/': typeof AdminClassroomsClassroomIdIndexRouteRoute
  '/admin/lesson/$lessonId/': typeof AdminLessonLessonIdIndexRouteRoute
  '/admin/project/$projectId/': typeof AdminProjectProjectIdIndexRouteRoute
  '/admin/schools/$schoolId/': typeof AdminSchoolsSchoolIdIndexRouteRoute
  '/teacher/classrooms/$classroomId/': typeof TeacherClassroomsClassroomIdIndexRouteRoute
  '/teacher/self-study-record/$classroomId/': typeof TeacherSelfStudyRecordClassroomIdIndexRouteRoute
  '/teacher/books/lessons/$lessonId/': typeof TeacherBooksLessonsLessonIdIndexRouteRoute
  '/teacher/books/lessons/$lessonId/slides/$slideId': typeof TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/': typeof AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/': typeof TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId': typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId': typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/homework/': typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/report/': typeof AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  '/admin/classrooms/$classroomId/students/$studentId/score/': typeof AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/homework/': typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/report/': typeof TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  '/teacher/classrooms/$classroomId/students/$studentId/score/': typeof TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/download'
    | '/login'
    | '/privacypolicy'
    | '/teacher'
    | '/admin/access'
    | '/admin/ai-usage'
    | '/admin/apks'
    | '/admin/errors'
    | '/admin/presets'
    | '/admin/trash'
    | '/admin/users'
    | '/homework/$homeworkId'
    | '/admin/'
    | '/teacher/'
    | '/admin/fsrs/docs'
    | '/admin/fsrs/schools'
    | '/admin/fsrs/system'
    | '/admin/slide/$slideId'
    | '/teacher/check/$batchId'
    | '/admin/analytics'
    | '/admin/books'
    | '/admin/classrooms'
    | '/admin/fsrs'
    | '/admin/phoneme-lab'
    | '/admin/schools'
    | '/admin/service-settings'
    | '/admin/speech'
    | '/admin/words'
    | '/teacher/assign'
    | '/teacher/books'
    | '/teacher/check'
    | '/teacher/classrooms'
    | '/teacher/self-study-record'
    | '/admin/lesson/$lessonId/drafts'
    | '/admin/lesson/$lessonId/trash'
    | '/admin/project/$projectId/drafts'
    | '/admin/project/$projectId/trash'
    | '/admin/classrooms/$classroomId'
    | '/admin/lesson/$lessonId'
    | '/admin/project/$projectId'
    | '/admin/schools/$schoolId'
    | '/teacher/classrooms/$classroomId'
    | '/teacher/self-study-record/$classroomId'
    | '/teacher/books/lessons/$lessonId'
    | '/teacher/books/lessons/$lessonId/slides/$slideId'
    | '/admin/classrooms/$classroomId/students/$studentId'
    | '/teacher/classrooms/$classroomId/students/$studentId'
    | '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
    | '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
    | '/admin/classrooms/$classroomId/students/$studentId/homework'
    | '/admin/classrooms/$classroomId/students/$studentId/report'
    | '/admin/classrooms/$classroomId/students/$studentId/score'
    | '/teacher/classrooms/$classroomId/students/$studentId/homework'
    | '/teacher/classrooms/$classroomId/students/$studentId/report'
    | '/teacher/classrooms/$classroomId/students/$studentId/score'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/download'
    | '/login'
    | '/privacypolicy'
    | '/admin/access'
    | '/admin/ai-usage'
    | '/admin/apks'
    | '/admin/errors'
    | '/admin/presets'
    | '/admin/trash'
    | '/admin/users'
    | '/homework/$homeworkId'
    | '/admin'
    | '/teacher'
    | '/admin/fsrs/docs'
    | '/admin/fsrs/schools'
    | '/admin/fsrs/system'
    | '/admin/slide/$slideId'
    | '/teacher/check/$batchId'
    | '/admin/analytics'
    | '/admin/books'
    | '/admin/classrooms'
    | '/admin/fsrs'
    | '/admin/phoneme-lab'
    | '/admin/schools'
    | '/admin/service-settings'
    | '/admin/speech'
    | '/admin/words'
    | '/teacher/assign'
    | '/teacher/books'
    | '/teacher/check'
    | '/teacher/classrooms'
    | '/teacher/self-study-record'
    | '/admin/lesson/$lessonId/drafts'
    | '/admin/lesson/$lessonId/trash'
    | '/admin/project/$projectId/drafts'
    | '/admin/project/$projectId/trash'
    | '/admin/classrooms/$classroomId'
    | '/admin/lesson/$lessonId'
    | '/admin/project/$projectId'
    | '/admin/schools/$schoolId'
    | '/teacher/classrooms/$classroomId'
    | '/teacher/self-study-record/$classroomId'
    | '/teacher/books/lessons/$lessonId'
    | '/teacher/books/lessons/$lessonId/slides/$slideId'
    | '/admin/classrooms/$classroomId/students/$studentId'
    | '/teacher/classrooms/$classroomId/students/$studentId'
    | '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
    | '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
    | '/admin/classrooms/$classroomId/students/$studentId/homework'
    | '/admin/classrooms/$classroomId/students/$studentId/report'
    | '/admin/classrooms/$classroomId/students/$studentId/score'
    | '/teacher/classrooms/$classroomId/students/$studentId/homework'
    | '/teacher/classrooms/$classroomId/students/$studentId/report'
    | '/teacher/classrooms/$classroomId/students/$studentId/score'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/download'
    | '/login'
    | '/privacypolicy'
    | '/teacher'
    | '/admin/access'
    | '/admin/ai-usage'
    | '/admin/apks'
    | '/admin/errors'
    | '/admin/presets'
    | '/admin/trash'
    | '/admin/users'
    | '/homework/$homeworkId'
    | '/admin/'
    | '/teacher/'
    | '/admin/fsrs/docs'
    | '/admin/fsrs/schools'
    | '/admin/fsrs/system'
    | '/admin/slide/$slideId'
    | '/teacher/check/$batchId'
    | '/admin/analytics/'
    | '/admin/books/'
    | '/admin/classrooms/'
    | '/admin/fsrs/'
    | '/admin/phoneme-lab/'
    | '/admin/schools/'
    | '/admin/service-settings/'
    | '/admin/speech/'
    | '/admin/words/'
    | '/teacher/assign/'
    | '/teacher/books/'
    | '/teacher/check/'
    | '/teacher/classrooms/'
    | '/teacher/self-study-record/'
    | '/admin/lesson/$lessonId/drafts'
    | '/admin/lesson/$lessonId/trash'
    | '/admin/project/$projectId/drafts'
    | '/admin/project/$projectId/trash'
    | '/admin/classrooms/$classroomId/'
    | '/admin/lesson/$lessonId/'
    | '/admin/project/$projectId/'
    | '/admin/schools/$schoolId/'
    | '/teacher/classrooms/$classroomId/'
    | '/teacher/self-study-record/$classroomId/'
    | '/teacher/books/lessons/$lessonId/'
    | '/teacher/books/lessons/$lessonId/slides/$slideId'
    | '/admin/classrooms/$classroomId/students/$studentId/'
    | '/teacher/classrooms/$classroomId/students/$studentId/'
    | '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
    | '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
    | '/admin/classrooms/$classroomId/students/$studentId/homework/'
    | '/admin/classrooms/$classroomId/students/$studentId/report/'
    | '/admin/classrooms/$classroomId/students/$studentId/score/'
    | '/teacher/classrooms/$classroomId/students/$studentId/homework/'
    | '/teacher/classrooms/$classroomId/students/$studentId/report/'
    | '/teacher/classrooms/$classroomId/students/$studentId/score/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  DownloadRouteRoute: typeof DownloadRouteRoute
  LoginRouteRoute: typeof LoginRouteRoute
  PrivacypolicyRouteRoute: typeof PrivacypolicyRouteRoute
  TeacherRouteRoute: typeof TeacherRouteRouteWithChildren
  HomeworkHomeworkIdRouteRoute: typeof HomeworkHomeworkIdRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/teacher': {
      id: '/teacher'
      path: '/teacher'
      fullPath: '/teacher'
      preLoaderRoute: typeof TeacherRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacypolicy': {
      id: '/privacypolicy'
      path: '/privacypolicy'
      fullPath: '/privacypolicy'
      preLoaderRoute: typeof PrivacypolicyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/': {
      id: '/teacher/'
      path: '/'
      fullPath: '/teacher/'
      preLoaderRoute: typeof TeacherIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/homework/$homeworkId': {
      id: '/homework/$homeworkId'
      path: '/homework/$homeworkId'
      fullPath: '/homework/$homeworkId'
      preLoaderRoute: typeof HomeworkHomeworkIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/trash': {
      id: '/admin/trash'
      path: '/trash'
      fullPath: '/admin/trash'
      preLoaderRoute: typeof AdminTrashRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/presets': {
      id: '/admin/presets'
      path: '/presets'
      fullPath: '/admin/presets'
      preLoaderRoute: typeof AdminPresetsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/errors': {
      id: '/admin/errors'
      path: '/errors'
      fullPath: '/admin/errors'
      preLoaderRoute: typeof AdminErrorsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/apks': {
      id: '/admin/apks'
      path: '/apks'
      fullPath: '/admin/apks'
      preLoaderRoute: typeof AdminApksRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ai-usage': {
      id: '/admin/ai-usage'
      path: '/ai-usage'
      fullPath: '/admin/ai-usage'
      preLoaderRoute: typeof AdminAiUsageRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access': {
      id: '/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AdminAccessRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/self-study-record/': {
      id: '/teacher/self-study-record/'
      path: '/self-study-record'
      fullPath: '/teacher/self-study-record'
      preLoaderRoute: typeof TeacherSelfStudyRecordIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/classrooms/': {
      id: '/teacher/classrooms/'
      path: '/classrooms'
      fullPath: '/teacher/classrooms'
      preLoaderRoute: typeof TeacherClassroomsIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/check/': {
      id: '/teacher/check/'
      path: '/check'
      fullPath: '/teacher/check'
      preLoaderRoute: typeof TeacherCheckIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/books/': {
      id: '/teacher/books/'
      path: '/books'
      fullPath: '/teacher/books'
      preLoaderRoute: typeof TeacherBooksIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/assign/': {
      id: '/teacher/assign/'
      path: '/assign'
      fullPath: '/teacher/assign'
      preLoaderRoute: typeof TeacherAssignIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/words/': {
      id: '/admin/words/'
      path: '/words'
      fullPath: '/admin/words'
      preLoaderRoute: typeof AdminWordsIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/speech/': {
      id: '/admin/speech/'
      path: '/speech'
      fullPath: '/admin/speech'
      preLoaderRoute: typeof AdminSpeechIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/service-settings/': {
      id: '/admin/service-settings/'
      path: '/service-settings'
      fullPath: '/admin/service-settings'
      preLoaderRoute: typeof AdminServiceSettingsIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/schools/': {
      id: '/admin/schools/'
      path: '/schools'
      fullPath: '/admin/schools'
      preLoaderRoute: typeof AdminSchoolsIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/phoneme-lab/': {
      id: '/admin/phoneme-lab/'
      path: '/phoneme-lab'
      fullPath: '/admin/phoneme-lab'
      preLoaderRoute: typeof AdminPhonemeLabIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/fsrs/': {
      id: '/admin/fsrs/'
      path: '/fsrs'
      fullPath: '/admin/fsrs'
      preLoaderRoute: typeof AdminFsrsIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/classrooms/': {
      id: '/admin/classrooms/'
      path: '/classrooms'
      fullPath: '/admin/classrooms'
      preLoaderRoute: typeof AdminClassroomsIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/books/': {
      id: '/admin/books/'
      path: '/books'
      fullPath: '/admin/books'
      preLoaderRoute: typeof AdminBooksIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/analytics/': {
      id: '/admin/analytics/'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/check/$batchId': {
      id: '/teacher/check/$batchId'
      path: '/check/$batchId'
      fullPath: '/teacher/check/$batchId'
      preLoaderRoute: typeof TeacherCheckBatchIdRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/slide/$slideId': {
      id: '/admin/slide/$slideId'
      path: '/slide/$slideId'
      fullPath: '/admin/slide/$slideId'
      preLoaderRoute: typeof AdminSlideSlideIdRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/fsrs/system': {
      id: '/admin/fsrs/system'
      path: '/fsrs/system'
      fullPath: '/admin/fsrs/system'
      preLoaderRoute: typeof AdminFsrsSystemRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/fsrs/schools': {
      id: '/admin/fsrs/schools'
      path: '/fsrs/schools'
      fullPath: '/admin/fsrs/schools'
      preLoaderRoute: typeof AdminFsrsSchoolsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/fsrs/docs': {
      id: '/admin/fsrs/docs'
      path: '/fsrs/docs'
      fullPath: '/admin/fsrs/docs'
      preLoaderRoute: typeof AdminFsrsDocsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/self-study-record/$classroomId/': {
      id: '/teacher/self-study-record/$classroomId/'
      path: '/self-study-record/$classroomId'
      fullPath: '/teacher/self-study-record/$classroomId'
      preLoaderRoute: typeof TeacherSelfStudyRecordClassroomIdIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/classrooms/$classroomId/': {
      id: '/teacher/classrooms/$classroomId/'
      path: '/classrooms/$classroomId'
      fullPath: '/teacher/classrooms/$classroomId'
      preLoaderRoute: typeof TeacherClassroomsClassroomIdIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/schools/$schoolId/': {
      id: '/admin/schools/$schoolId/'
      path: '/schools/$schoolId'
      fullPath: '/admin/schools/$schoolId'
      preLoaderRoute: typeof AdminSchoolsSchoolIdIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/project/$projectId/': {
      id: '/admin/project/$projectId/'
      path: '/project/$projectId'
      fullPath: '/admin/project/$projectId'
      preLoaderRoute: typeof AdminProjectProjectIdIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/lesson/$lessonId/': {
      id: '/admin/lesson/$lessonId/'
      path: '/lesson/$lessonId'
      fullPath: '/admin/lesson/$lessonId'
      preLoaderRoute: typeof AdminLessonLessonIdIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/classrooms/$classroomId/': {
      id: '/admin/classrooms/$classroomId/'
      path: '/classrooms/$classroomId'
      fullPath: '/admin/classrooms/$classroomId'
      preLoaderRoute: typeof AdminClassroomsClassroomIdIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/project/$projectId/trash': {
      id: '/admin/project/$projectId/trash'
      path: '/project/$projectId/trash'
      fullPath: '/admin/project/$projectId/trash'
      preLoaderRoute: typeof AdminProjectProjectIdTrashRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/project/$projectId/drafts': {
      id: '/admin/project/$projectId/drafts'
      path: '/project/$projectId/drafts'
      fullPath: '/admin/project/$projectId/drafts'
      preLoaderRoute: typeof AdminProjectProjectIdDraftsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/lesson/$lessonId/trash': {
      id: '/admin/lesson/$lessonId/trash'
      path: '/lesson/$lessonId/trash'
      fullPath: '/admin/lesson/$lessonId/trash'
      preLoaderRoute: typeof AdminLessonLessonIdTrashRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/lesson/$lessonId/drafts': {
      id: '/admin/lesson/$lessonId/drafts'
      path: '/lesson/$lessonId/drafts'
      fullPath: '/admin/lesson/$lessonId/drafts'
      preLoaderRoute: typeof AdminLessonLessonIdDraftsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/books/lessons/$lessonId/': {
      id: '/teacher/books/lessons/$lessonId/'
      path: '/books/lessons/$lessonId'
      fullPath: '/teacher/books/lessons/$lessonId'
      preLoaderRoute: typeof TeacherBooksLessonsLessonIdIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/classrooms/$classroomId/students/$studentId/': {
      id: '/teacher/classrooms/$classroomId/students/$studentId/'
      path: '/classrooms/$classroomId/students/$studentId'
      fullPath: '/teacher/classrooms/$classroomId/students/$studentId'
      preLoaderRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/classrooms/$classroomId/students/$studentId/': {
      id: '/admin/classrooms/$classroomId/students/$studentId/'
      path: '/classrooms/$classroomId/students/$studentId'
      fullPath: '/admin/classrooms/$classroomId/students/$studentId'
      preLoaderRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/books/lessons/$lessonId/slides/$slideId': {
      id: '/teacher/books/lessons/$lessonId/slides/$slideId'
      path: '/books/lessons/$lessonId/slides/$slideId'
      fullPath: '/teacher/books/lessons/$lessonId/slides/$slideId'
      preLoaderRoute: typeof TeacherBooksLessonsLessonIdSlidesSlideIdRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/classrooms/$classroomId/students/$studentId/score/': {
      id: '/teacher/classrooms/$classroomId/students/$studentId/score/'
      path: '/classrooms/$classroomId/students/$studentId/score'
      fullPath: '/teacher/classrooms/$classroomId/students/$studentId/score'
      preLoaderRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/classrooms/$classroomId/students/$studentId/report/': {
      id: '/teacher/classrooms/$classroomId/students/$studentId/report/'
      path: '/classrooms/$classroomId/students/$studentId/report'
      fullPath: '/teacher/classrooms/$classroomId/students/$studentId/report'
      preLoaderRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/teacher/classrooms/$classroomId/students/$studentId/homework/': {
      id: '/teacher/classrooms/$classroomId/students/$studentId/homework/'
      path: '/classrooms/$classroomId/students/$studentId/homework'
      fullPath: '/teacher/classrooms/$classroomId/students/$studentId/homework'
      preLoaderRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/classrooms/$classroomId/students/$studentId/score/': {
      id: '/admin/classrooms/$classroomId/students/$studentId/score/'
      path: '/classrooms/$classroomId/students/$studentId/score'
      fullPath: '/admin/classrooms/$classroomId/students/$studentId/score'
      preLoaderRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/classrooms/$classroomId/students/$studentId/report/': {
      id: '/admin/classrooms/$classroomId/students/$studentId/report/'
      path: '/classrooms/$classroomId/students/$studentId/report'
      fullPath: '/admin/classrooms/$classroomId/students/$studentId/report'
      preLoaderRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/classrooms/$classroomId/students/$studentId/homework/': {
      id: '/admin/classrooms/$classroomId/students/$studentId/homework/'
      path: '/classrooms/$classroomId/students/$studentId/homework'
      fullPath: '/admin/classrooms/$classroomId/students/$studentId/homework'
      preLoaderRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId': {
      id: '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
      path: '/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
      fullPath: '/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
      preLoaderRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId': {
      id: '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
      path: '/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
      fullPath: '/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId'
      preLoaderRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAccessRouteRoute: typeof AdminAccessRouteRoute
  AdminAiUsageRouteRoute: typeof AdminAiUsageRouteRoute
  AdminApksRouteRoute: typeof AdminApksRouteRoute
  AdminErrorsRouteRoute: typeof AdminErrorsRouteRoute
  AdminPresetsRouteRoute: typeof AdminPresetsRouteRoute
  AdminTrashRouteRoute: typeof AdminTrashRouteRoute
  AdminUsersRouteRoute: typeof AdminUsersRouteRoute
  AdminIndexRouteRoute: typeof AdminIndexRouteRoute
  AdminFsrsDocsRouteRoute: typeof AdminFsrsDocsRouteRoute
  AdminFsrsSchoolsRouteRoute: typeof AdminFsrsSchoolsRouteRoute
  AdminFsrsSystemRouteRoute: typeof AdminFsrsSystemRouteRoute
  AdminSlideSlideIdRouteRoute: typeof AdminSlideSlideIdRouteRoute
  AdminAnalyticsIndexRouteRoute: typeof AdminAnalyticsIndexRouteRoute
  AdminBooksIndexRouteRoute: typeof AdminBooksIndexRouteRoute
  AdminClassroomsIndexRouteRoute: typeof AdminClassroomsIndexRouteRoute
  AdminFsrsIndexRouteRoute: typeof AdminFsrsIndexRouteRoute
  AdminPhonemeLabIndexRouteRoute: typeof AdminPhonemeLabIndexRouteRoute
  AdminSchoolsIndexRouteRoute: typeof AdminSchoolsIndexRouteRoute
  AdminServiceSettingsIndexRouteRoute: typeof AdminServiceSettingsIndexRouteRoute
  AdminSpeechIndexRouteRoute: typeof AdminSpeechIndexRouteRoute
  AdminWordsIndexRouteRoute: typeof AdminWordsIndexRouteRoute
  AdminLessonLessonIdDraftsRouteRoute: typeof AdminLessonLessonIdDraftsRouteRoute
  AdminLessonLessonIdTrashRouteRoute: typeof AdminLessonLessonIdTrashRouteRoute
  AdminProjectProjectIdDraftsRouteRoute: typeof AdminProjectProjectIdDraftsRouteRoute
  AdminProjectProjectIdTrashRouteRoute: typeof AdminProjectProjectIdTrashRouteRoute
  AdminClassroomsClassroomIdIndexRouteRoute: typeof AdminClassroomsClassroomIdIndexRouteRoute
  AdminLessonLessonIdIndexRouteRoute: typeof AdminLessonLessonIdIndexRouteRoute
  AdminProjectProjectIdIndexRouteRoute: typeof AdminProjectProjectIdIndexRouteRoute
  AdminSchoolsSchoolIdIndexRouteRoute: typeof AdminSchoolsSchoolIdIndexRouteRoute
  AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute: typeof AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAccessRouteRoute: AdminAccessRouteRoute,
  AdminAiUsageRouteRoute: AdminAiUsageRouteRoute,
  AdminApksRouteRoute: AdminApksRouteRoute,
  AdminErrorsRouteRoute: AdminErrorsRouteRoute,
  AdminPresetsRouteRoute: AdminPresetsRouteRoute,
  AdminTrashRouteRoute: AdminTrashRouteRoute,
  AdminUsersRouteRoute: AdminUsersRouteRoute,
  AdminIndexRouteRoute: AdminIndexRouteRoute,
  AdminFsrsDocsRouteRoute: AdminFsrsDocsRouteRoute,
  AdminFsrsSchoolsRouteRoute: AdminFsrsSchoolsRouteRoute,
  AdminFsrsSystemRouteRoute: AdminFsrsSystemRouteRoute,
  AdminSlideSlideIdRouteRoute: AdminSlideSlideIdRouteRoute,
  AdminAnalyticsIndexRouteRoute: AdminAnalyticsIndexRouteRoute,
  AdminBooksIndexRouteRoute: AdminBooksIndexRouteRoute,
  AdminClassroomsIndexRouteRoute: AdminClassroomsIndexRouteRoute,
  AdminFsrsIndexRouteRoute: AdminFsrsIndexRouteRoute,
  AdminPhonemeLabIndexRouteRoute: AdminPhonemeLabIndexRouteRoute,
  AdminSchoolsIndexRouteRoute: AdminSchoolsIndexRouteRoute,
  AdminServiceSettingsIndexRouteRoute: AdminServiceSettingsIndexRouteRoute,
  AdminSpeechIndexRouteRoute: AdminSpeechIndexRouteRoute,
  AdminWordsIndexRouteRoute: AdminWordsIndexRouteRoute,
  AdminLessonLessonIdDraftsRouteRoute: AdminLessonLessonIdDraftsRouteRoute,
  AdminLessonLessonIdTrashRouteRoute: AdminLessonLessonIdTrashRouteRoute,
  AdminProjectProjectIdDraftsRouteRoute: AdminProjectProjectIdDraftsRouteRoute,
  AdminProjectProjectIdTrashRouteRoute: AdminProjectProjectIdTrashRouteRoute,
  AdminClassroomsClassroomIdIndexRouteRoute:
    AdminClassroomsClassroomIdIndexRouteRoute,
  AdminLessonLessonIdIndexRouteRoute: AdminLessonLessonIdIndexRouteRoute,
  AdminProjectProjectIdIndexRouteRoute: AdminProjectProjectIdIndexRouteRoute,
  AdminSchoolsSchoolIdIndexRouteRoute: AdminSchoolsSchoolIdIndexRouteRoute,
  AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute:
    AdminClassroomsClassroomIdStudentsStudentIdIndexRouteRoute,
  AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute:
    AdminClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute,
  AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute:
    AdminClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute,
  AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute:
    AdminClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute,
  AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute:
    AdminClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface TeacherRouteRouteChildren {
  TeacherIndexRouteRoute: typeof TeacherIndexRouteRoute
  TeacherCheckBatchIdRouteRoute: typeof TeacherCheckBatchIdRouteRoute
  TeacherAssignIndexRouteRoute: typeof TeacherAssignIndexRouteRoute
  TeacherBooksIndexRouteRoute: typeof TeacherBooksIndexRouteRoute
  TeacherCheckIndexRouteRoute: typeof TeacherCheckIndexRouteRoute
  TeacherClassroomsIndexRouteRoute: typeof TeacherClassroomsIndexRouteRoute
  TeacherSelfStudyRecordIndexRouteRoute: typeof TeacherSelfStudyRecordIndexRouteRoute
  TeacherClassroomsClassroomIdIndexRouteRoute: typeof TeacherClassroomsClassroomIdIndexRouteRoute
  TeacherSelfStudyRecordClassroomIdIndexRouteRoute: typeof TeacherSelfStudyRecordClassroomIdIndexRouteRoute
  TeacherBooksLessonsLessonIdIndexRouteRoute: typeof TeacherBooksLessonsLessonIdIndexRouteRoute
  TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute: typeof TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute
  TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute
  TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute
  TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute
  TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute
  TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute: typeof TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute
}

const TeacherRouteRouteChildren: TeacherRouteRouteChildren = {
  TeacherIndexRouteRoute: TeacherIndexRouteRoute,
  TeacherCheckBatchIdRouteRoute: TeacherCheckBatchIdRouteRoute,
  TeacherAssignIndexRouteRoute: TeacherAssignIndexRouteRoute,
  TeacherBooksIndexRouteRoute: TeacherBooksIndexRouteRoute,
  TeacherCheckIndexRouteRoute: TeacherCheckIndexRouteRoute,
  TeacherClassroomsIndexRouteRoute: TeacherClassroomsIndexRouteRoute,
  TeacherSelfStudyRecordIndexRouteRoute: TeacherSelfStudyRecordIndexRouteRoute,
  TeacherClassroomsClassroomIdIndexRouteRoute:
    TeacherClassroomsClassroomIdIndexRouteRoute,
  TeacherSelfStudyRecordClassroomIdIndexRouteRoute:
    TeacherSelfStudyRecordClassroomIdIndexRouteRoute,
  TeacherBooksLessonsLessonIdIndexRouteRoute:
    TeacherBooksLessonsLessonIdIndexRouteRoute,
  TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute:
    TeacherBooksLessonsLessonIdSlidesSlideIdRouteRoute,
  TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute:
    TeacherClassroomsClassroomIdStudentsStudentIdIndexRouteRoute,
  TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute:
    TeacherClassroomsClassroomIdStudentsStudentIdHomeworkHomeworkIdRouteRoute,
  TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute:
    TeacherClassroomsClassroomIdStudentsStudentIdHomeworkIndexRouteRoute,
  TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute:
    TeacherClassroomsClassroomIdStudentsStudentIdReportIndexRouteRoute,
  TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute:
    TeacherClassroomsClassroomIdStudentsStudentIdScoreIndexRouteRoute,
}

const TeacherRouteRouteWithChildren = TeacherRouteRoute._addFileChildren(
  TeacherRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DownloadRouteRoute: DownloadRouteRoute,
  LoginRouteRoute: LoginRouteRoute,
  PrivacypolicyRouteRoute: PrivacypolicyRouteRoute,
  TeacherRouteRoute: TeacherRouteRouteWithChildren,
  HomeworkHomeworkIdRouteRoute: HomeworkHomeworkIdRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
